// @ts-nocheck legacy file transformed to TS
import styled from '@emotion/styled'

export default styled.div`
  width: ${({ width }) => width || 0};
  height: ${({ height }) => height || 0};
`
